import { ymd, ymdhms } from './constants.js';
import dayjs from 'dayjs';
export const getDatePlusMinus = (operator, interval, intervalType, returnFormat = 'ymd', startOrEndOfDay, inputDateTime = '') => {
    let dateObject = inputDateTime && typeof inputDateTime === 'string' ? dayjs(inputDateTime) : dayjs();
    dateObject = inputDateTime && typeof inputDateTime === 'number' ? dayjs.unix(inputDateTime) : dateObject;
    dateObject = operator === '+' ? dateObject.add(interval, intervalType) : dateObject.subtract(interval, intervalType);
    dateObject = startOrEndOfDay === 'start' ? dateObject.startOf('day') : dateObject;
    dateObject = startOrEndOfDay === 'end' ? dateObject.endOf('day') : dateObject;
    let dateFormatted = returnFormat === 'ymd' ? dateObject.format(ymd) : '';
    dateFormatted = returnFormat === 'ymdhms' ? dateObject.format(ymdhms) : dateFormatted;
    dateFormatted = returnFormat === 'ymdhms' ? dateObject.format(ymdhms) : dateFormatted;
    return dateFormatted;
};
//# sourceMappingURL=getDatePlusMinus.js.map